import { render, staticRenderFns } from "./UiPulseLoading.vue?vue&type=template&id=2a160174&scoped=true&"
import script from "./UiPulseLoading.vue?vue&type=script&lang=js&"
export * from "./UiPulseLoading.vue?vue&type=script&lang=js&"
import style0 from "./UiPulseLoading.vue?vue&type=style&index=0&id=2a160174&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a160174",
  null
  
)

export default component.exports